import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../index.css';
import { Card, Button } from 'react-bootstrap';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const vacationTypeColors = {
  wypoczynkowy: '#0d6efd',
  bezpłatny: '#dc3545',
  okolicznościowy: '#ffc107',
};

const getVacationMarkerStyle = (color) => ({
  position: 'absolute',
  top: '2px',
  right: '2px',
  backgroundColor: color,
  color: 'white',
  width: '16px',
  height: '16px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '0.7rem',
  fontWeight: 'bold',
});

export default function MyCalendar({ vacations, dateRange, onDateChange }) {
  const [visible, setVisible] = useState(true);

  const toggleCalendar = () => {
    setVisible((prev) => !prev);
  };

  const getTileContent = ({ date, view }) => {
    if (view === 'month') {
      if (date.getDay() === 0 || date.getDay() === 6) {
        return null;
      }

      const vacationDay = vacations.find((vacation) => {
        const startDate = new Date(vacation.start_date);
        startDate.setHours(12, 0, 0, 0);
        const endDate = new Date(vacation.end_date);
        endDate.setHours(12, 0, 0, 0);
        const currentDate = new Date(date);
        currentDate.setHours(12, 0, 0, 0);
        return currentDate >= startDate && currentDate <= endDate;
      });

      if (vacationDay) {
        const typeRaw = vacationDay.vacation_type || 'default';
        const type = typeRaw.trim().toLowerCase();
        const color = vacationTypeColors[type] || vacationTypeColors.default;
        const vacationTypeInitial = type.charAt(0).toUpperCase();

        return (
          <div style={getVacationMarkerStyle(color)} title={typeRaw}>
            {vacationTypeInitial}
          </div>
        );
      }
    }
    return null;
  };
  return (
    <Card className="shadow-lg border-0" style={{ borderRadius: '20px', overflow: 'hidden' }}>
      <Card.Header
        style={{
          background: 'var(--pub-bg-alt)',
          border: 'none',
          padding: '1.5rem',
        }}
        className="d-flex justify-content-between align-items-center"
      >
        <h5 className="mb-0">
          {/* <FaCalendarAlt className="me-2" /> */}
          Kalendarz
        </h5>
        <Button
          variant="light"
          size="sm"
          onClick={toggleCalendar}
          className="d-inline-block d-md-none"
          style={{
            borderRadius: '10px',
            color: '#333',
            backgroundColor: 'white',
            border: 'none',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
          }}
        >
          {visible ? <FaChevronUp /> : <FaChevronDown />}
        </Button>
      </Card.Header>
      <Card.Body>
        <AnimatePresence>
          {visible && (
            <motion.div
              key="calendar"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              style={{ overflow: 'hidden' }}
            >
              {/* ✅ KALENDARZ WYŚRODKOWANY */}
              <div className="d-flex justify-content-center my-3">
                <Calendar
                  onChange={onDateChange}
                  value={dateRange}
                  selectRange={true}
                  locale="pl-PL"
                  tileContent={getTileContent}
                />
              </div>

              <div className="mt-3">
                <h6 className="mb-2 text-center">Legenda urlopów:</h6>
                <div className="d-flex justify-content-center flex-wrap gap-3">
                  {Object.entries(vacationTypeColors).map(([key, color]) => {
                    if (key === 'default') return null;
                    return (
                      <div key={key} className="d-flex align-items-center gap-2">
                        <span
                          style={{
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: color,
                            display: 'inline-block',
                          }}
                        ></span>
                        <small className="text-capitalize">{key}</small>
                      </div>
                    );
                  })}
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </Card.Body>
    </Card>
  );
}
